import React from "react";
import { Image, View, StyleSheet } from "react-native";
import { ArrowLeftIcon /*, PencilSimple, ChatCircle, Archive */ } from "@phosphor-icons/react";

import CustomButton from "../../../components/common/general/CustomButton/CustomButton";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import Pill from "../../../components/common/Pill/Pill";

interface Student {
  id: string;
  label: string;
  email?: string;
  profilePicture?: string;
  program?: string;
  status?: string;
  enrollmentDate?: string;
}

interface StudentProfileHeaderProps {
  student: Student;
  onBackPress: () => void;
  // onEditStudent?: () => void;
  // onSendMessage?: () => void;
  // onArchiveStudent?: () => void;
}

const getStudentStatusPill = (student: Student) => {
  if (student.status === "ENROLLED") {
    return {
      text: "ENROLLED",
      backgroundColor: "transparent",
      textColor: "#065F46",
      borderColor: "#D1FAE5",
      borderWidth: 1,
    };
  }
  if (student.status === "INVITED") {
    return {
      text: "INVITED",
      backgroundColor: "transparent",
      textColor: "#92400E",
      borderColor: "#ebbca0ff",
      borderWidth: 1,
    };
  }
  if (student.status === "EXPIRED") {
    return {
      text: "EXPIRED",
      backgroundColor: "transparent",
      textColor: "#374151",
      borderColor: "#8ea3c5ff",
      borderWidth: 1,
    };
  }
  return {
    text: student.status,
    backgroundColor: "transparent",
    textColor: "#374151",
    borderColor: "#374151",
    borderWidth: 1,
  };
};

const StudentProfileHeader: React.FC<StudentProfileHeaderProps> = ({
  student,
  onBackPress,
  // onEditStudent,
  // onSendMessage,
  // onArchiveStudent
}) => {
  if (!student) {
    return null; // or a loading skeleton
  }
  const statusPill = getStudentStatusPill(student);
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <View style={styles.identityBlock}>
          <View style={styles.avatar}>
            <Image
              source={{ uri: student.profilePicture || "https://via.placeholder.com/80" }}
              style={styles.avatarImage}
            />
          </View>
          <View style={styles.details}>
            <View style={styles.nameGroup}>
              <View style={styles.statusContainer}>
                <CustomText
                  text={student.label}
                  size="xl"
                  weight="ultraBold"
                  useTranslationText={false}
                  style={styles.studentName}
                />

                <View style={styles.pillContainer}>
                  <Pill
                    text={statusPill.text}
                    backgroundColor={statusPill.backgroundColor}
                    textColor={statusPill.textColor}
                    borderColor={statusPill.borderColor}
                    borderWidth={statusPill.borderWidth}
                  />
                </View>
              </View>
              <CustomText text={student.id} size="s" useTranslationText={false} style={styles.studentId} />
            </View>
          </View>
        </View>

        <View style={styles.actions}>
          <CustomButton
            text="Back to Students"
            onPress={onBackPress}
            styleType="primary"
            size="s"
            leftIcon={<ArrowLeftIcon size={16} color="#fff" />}
            textStyle={styles.actionButtonText}
          />

          {/* <CustomButton
            text="Edit Student"
            onPress={onEditStudent}
            styleType="primaryTransparentStroke"
            size="s"
            leftIcon={<PencilSimple size={16} color="#374151" />}
            textStyle={styles.actionButtonText}
          /> */}

          {/* <CustomButton
            text="Send Message"
            onPress={onSendMessage}
            styleType="primaryTransparentStroke"
            size="s"
            leftIcon={<ChatCircle size={16} color="#374151" />}
            textStyle={styles.actionButtonText}
          /> */}

          {/* <CustomButton
            text="Archive Student"
            onPress={onArchiveStudent}
            styleType="danger"
            size="s"
            leftIcon={<Archive size={16} color="#fff" />}
            textStyle={styles.actionButtonText}
          /> */}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 32,
    marginBottom: 32,
    backgroundColor: "#fff",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 2,
  },
  content: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  statusContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: 8,
  },
  pillContainer: {
    alignSelf: "center",
  },
  identityBlock: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  avatar: {
    width: 80,
    height: 80,
    borderRadius: 40,
    borderWidth: 3,
    borderColor: "#E5E7EB",
    overflow: "hidden",
    marginRight: 16,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  avatarImage: {
    width: "100%",
    height: "100%",
  },
  details: {
    flexDirection: "row",
    flex: 1,
  },
  nameGroup: {
    marginRight: 16,
  },
  studentName: {
    marginBottom: 6,
    fontSize: 32,
    lineHeight: 38,
  },
  studentId: {
    marginBottom: 4,
  },
  actions: {
    flexDirection: "row",
    gap: 12,
    alignItems: "flex-start",
  },
  actionButtonText: {
    lineHeight: 20,
  },
});

export default StudentProfileHeader;
